import React from 'react';
import Alert from '@amzn/meridian/alert';
import Column from '@amzn/meridian/column';
import { useSiteGatedFeature } from '../../../hooks/useSiteGatedFeature';
import { FLOW_MAP_FEATURE_NAME } from '../flowMap/FlowMapGated';
import BuffersPage from './index';

/**
 * Feature gate for the Buffers page, its own sidebar entry next to the Visual Flow Map.
 *
 * Gated on the same RCC_FLOW_MAP allowlist as the Flow Map: the two pages launch together over
 * the same Flow Monitoring data. As with the Flow Map, the sidebar link is not a control, so this
 * gate is what restricts who can see the page. Same resolution as FlowMapGated: nothing while the
 * flag resolves, the page when enabled, an explanation otherwise; fails closed.
 */
const BuffersGated: React.FC = () => {
  const isEnabled = useSiteGatedFeature(FLOW_MAP_FEATURE_NAME);

  if (isEnabled === null) {
    return null;
  }

  if (!isEnabled) {
    return (
      <Column spacing="400" spacingInset="500" data-testid="buffers-gated">
        <Alert type="neutral" data-testid="buffers-not-enabled">
          The Buffers page is coming soon and not yet available.
        </Alert>
      </Column>
    );
  }

  return <BuffersPage />;
};

export default BuffersGated;
